import React, { useState, useEffect } from "react";
import { putGasto as modifGasto } from "../helpers/rutaGastos";
import { getCuentasGasto } from "../helpers/rutaCuentaGasto";
import { Modal, Button } from "react-bootstrap";
import "animate.css";

const ModalFormGasto = ({ gasto, handleClose, show }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [cuentas, setCuentas] = useState({ data: [], loading: true });

  const [formValues, setFormValues] = useState({
    codgas: "",
    gasto: "",
    cuenta: "", // ✅ ObjectId CuentaGasto
  });

  // cargar cuentas una sola vez
  useEffect(() => {
    getCuentasGasto().then((resp) => {
      const lista = Array.isArray(resp) ? resp : resp?.cuentasgasto || [];
      setCuentas({ data: lista.filter((x) => x.activo), loading: false });
    });
  }, []);

  // cargar valores del gasto seleccionado cuando cambia
  useEffect(() => {
    if (gasto && gasto._id) {
      // gasto.cuenta puede venir como ObjectId o como objeto populado
      const cuentaId =
        typeof gasto.cuenta === "string"
          ? gasto.cuenta
          : gasto.cuenta?._id || "";

      setFormValues({
        codgas: gasto.codgas || "",
        gasto: gasto.gasto || "",
        cuenta: cuentaId,
      });
    }
  }, [gasto]);

  const handleChange = (e) => {
    setFormValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      gasto: String(formValues.gasto || "").trim(),
      cuenta: formValues.cuenta, // ✅ ObjectId
    };

    try {
      const resp = await modifGasto(gasto._id, payload);
      console.log("✅ Gasto actualizado:", resp);

      if (resp?.ok === false) {
        console.error("❌ Error:", resp?.error);
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1200);
    } catch (error) {
      console.error("❌ Error al actualizar gasto:", error);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Modificar Gasto</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group mt-2">
              <label>Cuenta</label>
              <select
                className="form-control"
                name="cuenta"
                required
                value={formValues.cuenta}
                onChange={handleChange}
                disabled={cuentas.loading}
              >
                <option value="">
                  {cuentas.loading
                    ? "Cargando cuentas..."
                    : "Seleccione una cuenta"}
                </option>
                {cuentas.data.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.cuenta}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group mt-3">
              <label>Gasto</label>
              <input
                type="text"
                className="form-control"
                name="gasto"
                required
                value={formValues.gasto}
                onChange={handleChange}
              />
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🖐</div>
          <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormGasto;